import { Configuration, PromotionsApi } from '@/api';
import useGetSupplierQuery from '@/api/queries/useGetSupplierQuery';
import CustomToast from '@/components/CustomToast';
import { Promotion, PromotionCreate } from '@/models/Promotion';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import PromotionForm from '@/modules/product/components/PromotionForm';
import { PromotionListPath } from '@/modules/product/paths';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { PercentBadgeIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const PromotionAdd = () => {
  const navigate = useNavigate();

  const promotionsApi = new PromotionsApi(new Configuration(useAuth));

  const { currentUser } = useAuth();

  const { supplierId } = currentUser();

  const { supplier, isLoading } = useGetSupplierQuery(supplierId);

  const handleSubmit = async (promotion: PromotionCreate | Promotion) => {
    try {
      const newPromotion = await promotionsApi.createPromotion(promotion);
      if (!newPromotion) {
        toast.custom((t) => (
          <CustomToast
            id={t.id}
            message={'Failed to create promotion. Please try again.'}
            visible={t.visible}
            variant="error"
          />
        ));
        return;
      }

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Promotion "${newPromotion.name}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(PromotionListPath);
    } catch (error) {
      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={'Failed to create promotion. Please try again.'}
          visible={t.visible}
          variant="error"
        />
      ));
      console.error('Error while creating promotion:', error);
    }
  };

  if (isLoading) {
    return;
  }

  return (
    <>
      <SettingsHeader title="Create Promotion" icon={<PercentBadgeIcon className="w-6 h-6" />} />

      <PromotionForm
        onSubmit={handleSubmit}
        currencyCode={supplier?.currencyCode}
        supplierId={supplierId}
      />
    </>
  );
};

export default PromotionAdd;
